var modules_f92dd299 = {"container":"_19p5mu","trigger-backdrop":"_kym71x","overlay":"_fgk2kg","backdrop":"_i2vm97","header":"_ky51hp","content":"_1izq29n","close":"_1l2wsuz"};
import "../../../assets/v9zjjZ-4.css";

export { modules_f92dd299 as default };
//# sourceMappingURL=Popover.module.less.js.map
